export default __webpack_public_path__ + "static/media/sponsor-RSPP.d4bd9262.svg";